export default __webpack_public_path__ + "static/media/636.51d97b85.png";